var React = require('react');

function MarsStroke (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M144 384a80 80 0 1 1 80-80 80 80 0 0 1-80 80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M372 64h-79a12 12 0 0 0-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1a12 12 0 0 0-17 0L224.5 133a12 12 0 0 0 0 17l14.1 14.1-18 18a143.3 143.3 0 0 0-76.7-22.1C64.5 160 0 224.5 0 304a144 144 0 1 0 265.9-76.7l18-18 14.1 14.1a12 12 0 0 0 17 0l28.3-28.3a12 12 0 0 0 0-17L329.2 164l17.5-17.5 16.9 16.9a12 12 0 0 0 20.5-8.5V76A12.19 12.19 0 0 0 372 64zM144 384a80 80 0 1 1 80-80 80 80 0 0 1-80 80z","className":"fa-primary","key":2})]);
}

MarsStroke.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = MarsStroke;

MarsStroke.default = MarsStroke;
